import { createFileRoute } from '@tanstack/react-router'
import OnboardingLayout from '@/pages/auth/onboarding/onboarding-layout'
import { ExtensionInstall } from '@/pages/auth/onboarding/components/extension-install'
import { useOnboardingTracking } from '@/hooks/use-onboarding-tracking'
import { z } from 'zod/v3';

const searchSchema = z.object({
  preference: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/onboarding/extension')({
  validateSearch: searchSchema,
  component: ExtensionPage,
})

function ExtensionPage() {
  const { track } = useOnboardingTracking()

  const sideContent = (
    <div>
      <h3 className="font-semibold">Extension Benefits</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Our extension captures context automatically, saving you 10+ minutes per documentation.
      </p>
    </div>
  )

  return (
    <OnboardingLayout currentStep={5} totalSteps={7} sideContent={sideContent}>
      <ExtensionInstall onAnalytics={track} />
    </OnboardingLayout>
  )
}